
import { Box } from "@mui/material"
import { isNil, max } from "lodash"
import BaseItem from "./BaseItem"
import { ItemLightDto } from "./ItemDataTypes"

export interface UpgradeItemProps {
    image: Array<string>
    title: Array<string>
    upgradeLabel?: Array<string>
    isMajor?: boolean,
    id: string,
    updateItem?: (value: ItemLightDto) => void,
    item?: ItemLightDto
    isObtained?: boolean
}


const UpgradeItem = (props: UpgradeItemProps) => {


    // let index = max([0, min([isObtained - 1, props.image.length])]) ?? 0;
    let state = props.item?.state ?? 0;
    let index = max([0, state - 1]) ?? 0
    let id = props.item?.id ?? props.id;
    

    const handleClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {

        let obtainedValue = (state + 1) % (props.image.length + 1)

        if (!isNil(props.updateItem)) {
            props.updateItem({ id: props.id, state: obtainedValue, isObtained: obtainedValue !== 0, title: props.title[index] } as ItemLightDto)
        }
    }

    const handleRightClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        e.preventDefault()

        let obtainedValue = (max([state - 1, 0]) ?? 0) % (props.image.length + 1);

        if (!isNil(props.updateItem))
            props.updateItem({ id: props.id, state: obtainedValue, isObtained: obtainedValue !== 0, title: props.title[index] } as ItemLightDto)

    }

    return <Box component="div"
        display="flex"
        width={32}
        height={32}
        justifyContent="center"
        sx={{
            color: index === props.image.length ? "lightgreen" : "default",
            position: "relative",
            textAlign: "center"

        }}
    >
        <BaseItem id={id} image={props.image[index]} title={props.title[index]} onClick={handleClick} onRightClick={handleRightClick} isObtained={props.item?.isObtained || index > 0} />
        {(props.item?.isObtained || index > 0) && <Box component="div" sx={{ position: "absolute", bottom: 0, fontWeight: "bold", userSelect: "none", textShadow: "1px 1px 2px black, 0 0 25px blue, 0 0 5px darkblue" }} onClick={handleClick} onContextMenu={handleRightClick} >{props.upgradeLabel?.[index]}</Box>}
    </Box>
}


export default UpgradeItem